import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import parseColor from '../util/parseColor';
import { styled } from '../styled';

const Icon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 26 26'
    fill='none'
    color='inherit'
  >
    <path
      d='M13 11.5556C13.7944 11.5556 14.4745 11.2727 15.0403 10.7069C15.606 10.1412 15.8889 9.46111 15.8889 8.66667C15.8889 7.87222 15.606 7.19213 15.0403 6.62639C14.4745 6.06065 13.7944 5.77778 13 5.77778C12.2056 5.77778 11.5255 6.06065 10.9597 6.62639C10.394 7.19213 10.1111 7.87222 10.1111 8.66667C10.1111 9.46111 10.394 10.1412 10.9597 10.7069C11.5255 11.2727 12.2056 11.5556 13 11.5556ZM5.77778 26V23.1111H11.5556V18.6333C10.3759 18.3685 9.32269 17.869 8.39583 17.1347C7.46898 16.4005 6.78889 15.4796 6.35556 14.3722C4.55 14.1556 3.03935 13.3671 1.82361 12.0069C0.60787 10.6468 0 9.05185 0 7.22222V5.77778C0 4.98333 0.28287 4.30324 0.848611 3.7375C1.41435 3.17176 2.09444 2.88889 2.88889 2.88889H5.77778V0H20.2222V2.88889H23.1111C23.9056 2.88889 24.5856 3.17176 25.1514 3.7375C25.7171 4.30324 26 4.98333 26 5.77778V7.22222C26 9.05185 25.3921 10.6468 24.1764 12.0069C22.9606 13.3671 21.45 14.1556 19.6444 14.3722C19.2111 15.4796 18.531 16.4005 17.6042 17.1347C16.6773 17.869 15.6241 18.3685 14.4444 18.6333V23.1111H20.2222V26H5.77778ZM5.77778 11.2667V5.77778H2.88889V7.22222C2.88889 8.13704 3.1537 8.96157 3.68333 9.69583C4.21296 10.4301 4.91111 10.9537 5.77778 11.2667ZM13 15.8889C14.2037 15.8889 15.2269 15.4676 16.0694 14.625C16.912 13.7824 17.3333 12.7593 17.3333 11.5556V2.88889H8.66667V11.5556C8.66667 12.7593 9.08796 13.7824 9.93056 14.625C10.7731 15.4676 11.7963 15.8889 13 15.8889ZM20.2222 11.2667C21.0889 10.9537 21.787 10.4301 22.3167 9.69583C22.8463 8.96157 23.1111 8.13704 23.1111 7.22222V5.77778H20.2222V11.2667Z'
      fill='currentColor'
    />
  </svg>,
  'Trophy',
);

const ColoredIcon = styled(Icon)(({ theme, color }) => ({
  color: parseColor(theme, color),
}));

export default ColoredIcon;
